import type { BpmnProcessModel } from '../bpmn/types';
import { Badge } from '../components/Badge';
import { Button } from '../components/Button';
import type { BadgeTone } from '../components/Badge';

export interface ElementPickerProps {
  process: BpmnProcessModel;
  selectedElementId: string | null;
  onSelect(elementId: string): void;
  /** 実行詳細で使うときの状態表示。app詳細では省略する。 */
  stateOf?(elementId: string): { tone: BadgeTone; label: string } | null;
}

/**
 * BPMNDIが無い定義のための要素一覧。
 *
 * bpmn-jsはDIの無い要素を1つも描かないため、図だけに頼ると「何も無い定義」に見えてしまう。
 * 図が描けなくても、要素を選んで実装・入出力・出典・回答へ辿れることを保つ。
 */
export function ElementPicker({
  process,
  selectedElementId,
  onSelect,
  stateOf,
}: ElementPickerProps) {
  const entries = Object.values(process.elements);
  if (entries.length === 0) {
    return <p className="hint">このプロセスには表示できる要素がありません。</p>;
  }

  return (
    <ul className="element-picker">
      {entries.map((element) => {
        const state = stateOf?.(element.id) ?? null;
        return (
          <li key={element.id}>
            <Button
              variant={element.id === selectedElementId ? 'primary' : 'default'}
              onClick={() => onSelect(element.id)}
            >
              {state && <Badge tone={state.tone}>{state.label}</Badge>}
              <span>{element.name || element.id}</span>
              <code>{element.id}</code>
            </Button>
          </li>
        );
      })}
    </ul>
  );
}
